import React, { Component } from 'react';
import { withStyles, CircularProgress, Box } from '@material-ui/core';

const styles = () => ({
  loaderContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

class Loader extends Component<any> {
  render() {
    const { classes } = this.props;
    return (
      <Box className={classes.loaderContainer}>
        <CircularProgress />
      </Box>
    );
  }
}

export default withStyles(styles as any, { withTheme: true })(Loader);
